/** Debounced Resize() jQuery Plugin */
var $ = require('jquery');

"use strict";

var PLUGIN_NAME = "smartresize";

	var debounce = function (func, threshold, execAsap) {
		var timeout;
		return function debounced () {
			var obj = this, args = arguments;
			function delayed () {
				if (!execAsap)
					func.apply(obj, args);
				timeout = null;
			}
			if (timeout)
				clearTimeout(timeout);
			else if (execAsap)
				func.apply(obj, args);
			timeout = setTimeout(delayed, threshold || 100);
		};
	};
	// smartresize
	$.fn[PLUGIN_NAME] = function(fn){  return fn ? this.bind('resize', debounce(fn)) : this.trigger(PLUGIN_NAME); };



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.debouncedResize.js